export const routes = [
  {
    name: 'contract_list',
    path: '/contract',
    componentConfig: [
      {
        component: 'EndpointListContainer',
        props: {
          endpoint: 'contract',
          slice: 'contract/contract/list',
          selectAction: {
            preview: {
              meta: {
                modal: {
                  body: [
                    {
                      component: 'ContractDetailContainer'
                    }
                  ]
                }
              }
            },
            edit: {
              type: 'contract/contract/edit/start',
              meta: {
                modal: {
                  title: 'contract.actions.update',
                  body: [
                    {
                      component: 'ContractEditForm'
                    }
                  ]
                }
              }
            }
          }
        },
        children: [
          {
            component: 'Grid',
            props: {
              title: 'contract.module.name',
              config: {
                columns: {
                  number: {
                    sortable: true,
                    label: 'contract.entity.number'
                  },
                  company: {
                    sortable: true,
                    label: 'contract.entity.company',
                    display: {
                      type: 'objectProps',
                      props: ['name']
                    }
                  },
                  items: {
                    label: 'contract.entity.items',
                    display: {
                      type: 'function',
                      renderer: ({ value }) => {
                        let budgetLines = [];

                        value.forEach(item => {
                          const name = `${item.budgetLine.listOrder || ''} ${
                            item.budgetLine.name
                          }`;

                          if (!budgetLines.includes(name)) {
                            budgetLines.push(name);
                          }
                        });

                        if (budgetLines.length > 3) {
                          budgetLines = budgetLines.slice(0, 3);
                          return `${budgetLines.join(', ')} ...`;
                        }

                        return budgetLines.join(', ');
                      }
                    }
                  },
                  signDate: {
                    sortable: true,
                    label: 'contract.entity.signDate',
                    display: {
                      type: 'relativeDate'
                    }
                  },
                  updatedAt: {
                    sortable: true,
                    label: 'contract.entity.updatedAt',
                    display: {
                      type: 'relativeDate'
                    }
                  }
                },
                filtersConfig: [
                  {
                    label: 'contract.filter.company',
                    property: 'company',
                    type: 'eq',
                    inputConfig: {
                      name: 'company',
                      type: 'wideEndpointCombo',
                      endpoint: 'companyCombo',
                      slice: 'contract/company/combo',
                      displayField: 'name'
                    }
                  }
                ],
                actions: [
                  {
                    label: 'contract.actions.create',
                    type: 'create',
                    icon: 'plus',
                    action: {
                      type: 'contract/contract/edit/start',
                      meta: {
                        modal: {
                          title: 'contract.create',
                          body: [
                            {
                              component: 'ContractCreateForm'
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                recordActions: [
                  {
                    label: 'contract.recordActions.edit',
                    type: 'edit',
                    icon: 'pen',
                    visibleOnHover: true,
                    hideLabel: true,
                    action: {
                      type: 'contract/contract/edit/start',
                      meta: {
                        modal: {
                          title: 'contract.update',
                          body: [
                            {
                              component: 'ContractEditForm'
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    label: 'contract.recordActions.addProtocol',
                    type: 'addProtocol',
                    icon: 'plus',
                    hidden: true,
                    passItemProps: ['id'],
                    action: {
                      type: 'contract/protocol/create',
                      sideEffects: {
                        'contract/protocol/create_success': [
                          {
                            type: 'protocol/protocol/create/start',
                            _convertPayload: 'extractAPI',
                            meta: {
                              modal: {
                                title: 'protocol.actions.create',
                                body: [
                                  {
                                    component: 'ProtocolCreateForm'
                                  }
                                ]
                              }
                            }
                          }
                        ]
                      },
                      meta: {
                        API: {
                          endpoint: 'contract',
                          operation: 'addProtocol'
                        }
                      }
                    }
                  },
                  {
                    label: 'contract.recordActions.pdf',
                    type: 'pdf',
                    icon: 'pdf',
                    hidden: true,
                    passItemProps: ['id'],
                    action(data) {
                      let name = `contract-${data.id}`;
                      // I do not see how to do it "prettier"
                      fetch(`/api/pdf/contract/${data.id}`, {
                        headers: {
                          Authorization: `Bearer ${localStorage.getItem(
                            'token'
                          )}`
                        }
                      })
                        .then(response => {
                          // Extract file name from header
                          response.headers.forEach(header => {
                            if (header.indexOf('attachment;') > -1) {
                              const parts = header.split('=');
                              name = parts[1].replaceAll('"', '');
                            }
                          });
                          return response.blob();
                        })
                        .then(blob => {
                          if (!(window.URL && window.URL.createObjectURL)) {
                            alert('Update your browser!!!');
                            return;
                          }
                          const blobURL = window.URL.createObjectURL(blob);
                          const tmpLink = document.createElement('a');
                          tmpLink.style.display = 'none';
                          tmpLink.href = blobURL;
                          tmpLink.setAttribute('target', '_blank');
                          tmpLink.setAttribute('download', `${name}`);
                          tmpLink.click();
                        });
                    }
                  },
                  {
                    label: 'contract.recordActions.delete',
                    type: 'delete',
                    icon: 'trash',
                    hideLabel: true,
                    action: {
                      type: 'contract/contract/list/delete',
                      meta: {
                        API: {
                          endpoint: 'contract',
                          operation: 'delete'
                        },
                        confirm: {
                          props: {
                            title: 'ims.confirm.delete.title',
                            message: 'ims.confirm.delete.message',
                            confirmText: 'ims.confirm.delete.confirmText',
                            cancelText: 'ims.confirm.delete.cancelText'
                          },
                          confirmed: false
                        }
                      }
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    ],
    exact: true,
    section: true,
    module: 'contract',
    label: 'contract.module.name',
    icon: 'handshake'
  }
];
